import { Label, NumberInput, Textarea } from "@tellescope/ui";
import { type useEventFormDialogContents } from "../../../../hooks";
import { useTranslation } from "react-i18next";

export interface NotesSectionProps extends Pick<ReturnType<typeof useEventFormDialogContents>, "form" | "event"> {}

export const NotesSection = ({ form, event }: NotesSectionProps) => {
  const { t } = useTranslation("calendar");
  const appointmentHasStarted = event ? event.startTimeInMS < new Date().getTime() : false;
  const differenceInMins = event
    ? Math.floor(new Date().getTime() / 1000 / 60) - Math.floor(event.startTimeInMS / 1000 / 60)
    : undefined;

  return (
    <form {...form.getFormProps()} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="actual-duration">{t("Actual duration (min)")}</Label>
        <NumberInput
          id="actual-duration"
          onChange={(value) => form.setFieldValue("actualDuration", value ?? 0)}
          onBlur={() => form.getCustomFieldProps("actualDuration").onBlur()}
          placeholder={t("Post-appointment tracking")}
          disabled={!appointmentHasStarted}
          options={
            differenceInMins === undefined
              ? undefined
              : [
                  {
                    label: t("Now ({{duration}} mins)", { duration: differenceInMins.toLocaleString() }),
                    value: differenceInMins,
                  },
                ]
          }
        />
        <p className="text-xs text-muted-foreground">{t("Recorded after the appointment completes.")}</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="internal-notes">{t("Internal notes")}</Label>
        <Textarea {...form.getFieldProps("internalNotes")} placeholder={t("Notes visible only to staff...")} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="booking-reason">{t("Reason for booking (read-only)")}</Label>
        <Textarea
          {...form.getFieldProps("reason")}
          placeholder={t("No reason provided by patient at booking")}
          disabled
          className="disabled:opacity-100 disabled:text-muted-foreground disabled:bg-gray-50 resize-none"
        />
      </div>
    </form>
  );
};
